export const DEFAULT_NAVIGATION_SLOT_ITEMS = [
  {
    id: null, name: 'Latest', url: '/feeds/latest', order: 0, published: false,
  },
  {
    id: null, name: 'Contributors', url: '/contributors', order: 1, published: false,
  },
  {
    id: null, name: 'Funds', url: '/funds', order: 2, published: false,
  },
  {
    id: null, name: '', url: '', order: 3, published: false,
  },
  {
    id: null, name: '', url: '', order: 4, published: false,
  },
  {
    id: null, name: '', url: '', order: 5, published: false,
  },
  {
    id: null, name: '', url: '', order: 6, published: false,
  },
];

export function navigationSlotTemplateForOrder(order) {
  const row = DEFAULT_NAVIGATION_SLOT_ITEMS.find(d => d.order === order);
  return row ? { ...row } : {
    id: null, name: '', url: '', order, published: false,
  };
}
